// extracted by mini-css-extract-plugin
export default {"errorText":"errorMessage_errorText__vtgOZ","slideTransition":"errorMessage_slideTransition__fDTr6"};